import { createSlice } from "@reduxjs/toolkit"
import { getLocalTimeZone, today } from "@internationalized/date"

const currentDate = today(getLocalTimeZone()).toString();

const initialState = {
  openModal: false,
  action: "FORM" as "FORM" | "CONFIRMATION" | "SUCCESS",
  formData: {
    bankAccountIdentification: "",
    amount: "",
    date: currentDate,
    cuit: "",
    currency: "1",
  },
};

const echeqSlice = createSlice({
    name: "echeq",
    initialState,
    reducers: {
        updateFormData: (state, action) => {
            state.formData = { 
                ... state.formData,
                ...action.payload 
            } 
        },
        updateAction: (state, action) => {
            state.action = action.payload
        },
        resetForm: (state) => { 
            state.formData = initialState.formData
            state.action = "FORM"
        },
        openModal: (state) => {
            state.openModal = true
        },
        closeModal: (state) => {
            state.openModal = false
            state.formData = initialState.formData
            state.action = "FORM"
        }
    },
  })

  export const { updateFormData, resetForm, openModal, closeModal, updateAction } = echeqSlice.actions
  export default echeqSlice.reducer